import { DatabaseIcon, NotSchedulesvg, ScheduleSvg } from '../../../../../CommonComponents/svgs/Svgs';

import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';
import { replaceUnderscoresWithSpaces } from '../../../../../../utils/commonFunctions';
import FaultReportDetails from './FaultReportDetails';
import GroupButtonList from '../../../../../CommonComponents/GroupButtonList';
import { DefinedFaultTask } from '../../../utils/scenario-types';
import { FC, useEffect } from 'react';
import { getUtcFormattedDate } from '../../../utils/helperFunction';

export const MenuList = [{ name: 'Delete' }]

interface FaultReportProps {
    openMenu: string | boolean
    setOpenMenu: (openMenu: string | boolean) => void
    onMenuClick: (faultId: string) => void
    fault: DefinedFaultTask
    selectedFault: string | null
    onSelectFault: (faultId: string) => void
    faultType: 'SCHEDULED' | 'NOT_SCHEDULED'
}

const FaultReport: FC<FaultReportProps> = ({ fault, faultType, selectedFault, onSelectFault, openMenu, setOpenMenu, onMenuClick }) => {


    return (
        <div className={`fault__report__container ${selectedFault === fault.faultId && 'active'}`}
            onClick={() => { onSelectFault(fault.faultId) }}
        >
            <div className='fault__report__container__header'>
                <div className='header__details__container'>
                    <div className='system__details__container'>
                        <DatabaseIcon />
                        <span>{fault.faultSystem}</span>
                    </div>
                    <div className='time__details__container'>
                        <span>{getUtcFormattedDate(fault?.['startTime'] || 0)}</span>
                        <CustomToolTip title={fault?.['message']} placement="top">
                            {fault.status === 'SCHEDULED' && <ScheduleSvg />}
                            {fault.status !== 'SCHEDULED' && <NotSchedulesvg />}
                        </CustomToolTip>
                    </div>
                </div>
                <div className='header__details__container'>
                    <div className='system__details__container'>
                        <span className='opacity-75'>{replaceUnderscoresWithSpaces(fault?.['faultName'])}</span>
                    </div>
                    <div onClick={(e) => { e.stopPropagation() }} className='button__group__container'>
                        <GroupButtonList
                            id={fault.faultId}
                            placement='left'
                            open={openMenu}
                            toggle={(value) => {
                                setOpenMenu(value)
                            }}
                            buttons={MenuList}
                            onClick={() => {
                                onMenuClick(fault.faultId)
                            }}
                        >
                            <i className='fe fe-more-vertical ' />
                        </GroupButtonList>
                    </div>
                </div>
            </div>
            <FaultReportDetails Fault={fault} />
        </div>
    )
}

export default FaultReport